"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.object.keys.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index = require("@/model/exchange/index");

var _finance = require("@/model/finance/finance");

var _settings = require("@/model/settings");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _message = require("@/components/dialog/message");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _index2 = require("@/model/assets/index");

var _digital = require("@/assets/js/digital");

var _formatDate = require("@/assets/js/formatDate");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _i18n = require("@/assets/js/i18n");

var _financialDialog = _interopRequireDefault(require("../../../finances/components/financial-management/financial-dialog"));

var _confirmDialog = _interopRequireDefault(require("../../../finances/components/financial-management/confirm-dialog.vue"));

var _keymap = require("@/assets/js/keymap.js");

var _stationSetting = require("@/assets/js/stationSetting");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import TopTitle from "../../components/Title";
var _default = {
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default,
    InputNumber: _InputNumber.default,
    FinancialDialog: _financialDialog.default,
    ConfirmDialogContent: _confirmDialog.default
  },
  data: function data() {
    return {
      financialHoldStatusMaps: _keymap.financialHoldStatusMaps,
      coinData: {},
      // 币种数据列表
      assetsList: {},
      // 资产数据列表
      historyPositionList: [],
      // 理财产品历史持仓数据列表
      symbolList: {},
      // 交易币种表
      confirmDialogTitle: this.translateTitle("\u91CF\u5316\u7406\u8D22"),
      takeOutDialogTitle: this.translateTitle("\u5B9A\u671F\u5B58\u6B3E\u53D6\u51FA"),
      takeOutDialogVisible: false,
      takeOutDialogLoading: true,
      active: 1,
      typeActive: 1,
      productType: 1,
      contractMap: {},
      rowData: {},
      item_name: "",
      u_valuation: "",
      last_profit: "",
      pre_earnings_amount: "",
      total_profit: "",
      assetsShow: "",
      sellNumber: "",
      dataList: [],
      historyPositionDataList: [],
      recordList: [],
      confirmDialogLoading: true,
      btnLoading: false,
      isChecked: false,
      detailLoading: true,
      oldTableList: [],
      stepActive: 1,
      rate: 1,
      rate1: 1,
      rate2: 1,
      currTab: 1,
      all_last_valuation: {
        aed: "--",
        cny: "--",
        cnye: "--",
        hkd: "--",
        jpy: "--",
        krw: "--",
        usd: "--",
        usdt: "--"
      },
      all_total_valuation: {
        aed: "--",
        cny: "--",
        cnye: "--",
        hkd: "--",
        jpy: "--",
        krw: "--",
        usd: "--",
        usdt: "--"
      },
      all_pre_earnings_valuation: {
        aed: "--",
        cny: "--",
        cnye: "--",
        hkd: "--",
        jpy: "--",
        krw: "--",
        usd: "--",
        usdt: "--"
      },
      assetsShowCurrency: {
        aed: "--",
        cny: "--",
        cnye: "--",
        hkd: "--",
        jpy: "--",
        krw: "--",
        usd: "--",
        usdt: "--"
      },
      digitalCoinList: {
        list: {}
      },
      //加密货币
      legalCoinList: {
        list: {}
      },
      //法币
      currIndex: 1,
      currIndexPosition: 1,
      tabList: [{
        value: "1",
        label: "金融理财"
      } // {
      //   value: "2",
      //   label: "矿池",
      // },
      ],
      tabListPosition: [{
        value: "1",
        label: "持仓中"
      }, {
        value: "2",
        label: "历史持仓"
      }],
      typeList: [{
        value: "1",
        label: "全部"
      }, {
        value: "2",
        label: "存入记录"
      }, {
        value: "3",
        label: "收益明细"
      }, {
        value: "4",
        label: "取出明细"
      }],
      tableLoading: true,
      historytableLoading: true,
      financialDialogVisible: false,
      confirmDialogVisible: false,
      successDialogVisible: false,
      detailDialogVisible: false,
      productId: "",
      apiAssetsInfo: "",
      holderPositionInfo: {
        product_id: 33,
        product_name: "--",
        item_id: 10007,
        channel_id: 101,
        item_type: 1,
        to_item_id: 10069,
        to_item_id_price: "--",
        product_type: 1,
        rate_type: 1,
        quant_tag: 0,
        annual_rate: 1,
        min_fluctuation_annual_rate: "0.0000",
        max_fluctuation_annual_rate: "0.0000",
        day_rate: "--",
        current_rate: "--",
        period: 1,
        start_time: 1620370800,
        stop_time: 1620975600,
        lock_period: 7,
        amount: 0,
        lowest_amount: 0,
        total_amount: "--",
        min_amount: 1000,
        max_amount: 200000,
        per_min_num: 1,
        per_max_num: 200,
        number_precision: 2,
        price_precision: 2,
        amount_precision: 2,
        trader_profit: 0,
        status: 7,
        union_product_id: 0,
        union_order_by: 1,
        is_union_master: 0,
        public_raise_amount: "--",
        ico_buy_condition: 1,
        ico_user_register_time: 0,
        is_hide: 0,
        is_show_list: 1,
        is_recommand: 1,
        is_delete: 0,
        access_type: 1,
        order_by: 1,
        i18n_lang: "static_finances_product_product_name_330",
        create_time: 1620324487,
        update_time: 1620975363,
        detail: {
          product_id: 33,
          product_intro: "",
          inout_rule: "",
          earnings_rule: "",
          product_code: "--",
          strategy: "",
          ico_url: "https://top6688.zendesk.com/hc/zh-cn/articles/4402147339921-%E8%AE%A4%E8%AF%86-O3",
          ico_eg: "",
          buy_rule: "--",
          risk_tip: "--",
          join_rule: "",
          i18n_lang: "ico_url_31,ico_eg_33,buy_rule_31,risk_tip_31,join_rule_0,product_code_33"
        },
        item_name: "USDT",
        item_url: "https://imgs-dev.aevwjlae.com/admin/20201113/03397693702.png",
        to_item_url: "https://imgs-dev.aevwjlae.com/admin/20210505/98506549656.png",
        to_item_name: "--",
        end_time: 1621580400,
        user_profit: 1,
        show_profit: 0
      },
      productInfo: {
        product_id: 33,
        product_name: "--",
        item_id: 10007,
        channel_id: 101,
        item_type: 1,
        to_item_id: 10069,
        to_item_id_price: "--",
        product_type: 1,
        rate_type: 1,
        quant_tag: 0,
        annual_rate: 1,
        min_fluctuation_annual_rate: "0.0000",
        max_fluctuation_annual_rate: "0.0000",
        day_rate: "--",
        current_rate: "--",
        period: 1,
        start_time: 1620370800,
        stop_time: 1620975600,
        lock_period: 7,
        amount: 0,
        lowest_amount: 0,
        total_amount: "--",
        min_amount: 1000,
        max_amount: 200000,
        per_min_num: 1,
        per_max_num: 200,
        number_precision: 2,
        price_precision: 2,
        amount_precision: 2,
        trader_profit: 0,
        status: 7,
        union_product_id: 0,
        union_order_by: 1,
        is_union_master: 0,
        public_raise_amount: "--",
        ico_buy_condition: 1,
        ico_user_register_time: 0,
        is_hide: 0,
        is_show_list: 1,
        is_recommand: 1,
        is_delete: 0,
        access_type: 1,
        order_by: 1,
        i18n_lang: "static_finances_product_product_name_330",
        create_time: 1620324487,
        update_time: 1620975363,
        detail: {
          product_id: 33,
          product_intro: "",
          inout_rule: "",
          earnings_rule: "",
          product_code: "--",
          strategy: "",
          ico_url: "https://top6688.zendesk.com/hc/zh-cn/articles/4402147339921-%E8%AE%A4%E8%AF%86-O3",
          ico_eg: "",
          buy_rule: "--",
          risk_tip: "--",
          join_rule: "",
          i18n_lang: "ico_url_31,ico_eg_33,buy_rule_31,risk_tip_31,join_rule_0,product_code_33"
        },
        item_name: "USDT",
        item_url: "https://imgs-dev.aevwjlae.com/admin/20201113/03397693702.png",
        to_item_url: "https://imgs-dev.aevwjlae.com/admin/20210505/98506549656.png",
        to_item_name: "--",
        end_time: 1621580400,
        user_profit: 1,
        show_profit: 0
      },
      apiProductInfo: {
        product_id: 1,
        product_name: "--",
        item_id: 10007,
        channel_id: 101,
        item_type: 1,
        to_item_id: 10069,
        to_item_id_price: "--",
        product_type: 1,
        rate_type: 1,
        quant_tag: 0,
        annual_rate: "--",
        min_fluctuation_annual_rate: "0.0000",
        max_fluctuation_annual_rate: "0.0000",
        day_rate: "--",
        current_rate: "--",
        period: 1,
        start_time: 1620370800,
        stop_time: 1620975600,
        lock_period: 7,
        amount: 0,
        lowest_amount: 0,
        total_amount: "--",
        min_amount: 1000,
        max_amount: 200000,
        per_min_num: 1,
        per_max_num: 200,
        number_precision: 2,
        price_precision: 2,
        amount_precision: 2,
        trader_profit: 0,
        status: 7,
        union_product_id: 0,
        union_order_by: 1,
        is_union_master: 0,
        public_raise_amount: "--",
        ico_buy_condition: 1,
        ico_user_register_time: 0,
        is_hide: 0,
        is_show_list: 1,
        is_recommand: 1,
        is_delete: 0,
        access_type: 1,
        order_by: 1,
        i18n_lang: "static_finances_product_product_name_330",
        create_time: 1620324487,
        update_time: 1620975363,
        detail: {
          product_id: 33,
          product_intro: "",
          inout_rule: "",
          earnings_rule: "",
          product_code: "--",
          strategy: "",
          ico_url: "https://top6688.zendesk.com/hc/zh-cn/articles/4402147339921-%E8%AE%A4%E8%AF%86-O3",
          ico_eg: "",
          buy_rule: "--",
          risk_tip: "--",
          join_rule: "",
          i18n_lang: "ico_url_31,ico_eg_33,buy_rule_31,risk_tip_31,join_rule_0,product_code_33"
        },
        item_name: "USDT",
        item_url: "https://imgs-dev.aevwjlae.com/admin/20201113/03397693702.png",
        to_item_url: "https://imgs-dev.aevwjlae.com/admin/20210505/98506549656.png",
        to_item_name: "--",
        end_time: 1621580400,
        user_profit: 1,
        show_profit: 0
      },
      coinInfoMap: {},
      pageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      historyPositionPageInfo: {
        pageCount: 0,
        pageTotal: 0,
        pageSize: 10,
        pageCurrent: 1
      },
      voucherInterval: null,
      voucherIntervalV2: null
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.getStaticTableInfo(13);

            case 2:
              _context2.next = 4;
              return _this.getAssetsList();

            case 4:
              _this.getAllItemDataOnce();

              _this.voucherInterval = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.getAssetsList();

                      case 2:
                        _this.getAllItemData();

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 3000);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  destroyed: function destroyed() {
    clearInterval(this.voucherInterval);
    clearInterval(this.voucherIntervalV2);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.voucherInterval);
    clearInterval(this.voucherIntervalV2);
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    dailyIncome: function dailyIncome() {
      var tempValue = "--";

      if (this.sellNumber != "") {
        //  计息中取出才计算取出收益：  持仓金额*取出年化/365*已经计息的天数(days)
        tempValue = this.sellNumber * this.holderPositionInfo.annual_rate / 365 * this.holderPositionInfo.days; // 截断

        tempValue = tempValue.toString().substring(0, tempValue.toString().indexOf(".") + 2 + 1);
      } else {
        tempValue = "--";
      }

      return tempValue;
    },
    sortCoinData: function sortCoinData() {
      return this.sortObj(this.coinData);
    },
    recordListComputed: function recordListComputed() {
      var tempArr = [];

      if (this.typeActive == 1) {
        tempArr = this.recordList;
      } else if (this.typeActive == 2) {
        this.recordList.forEach(function (element) {
          if (element.asset_type == 1 || element.asset_type == 2 || element.asset_type == 8) {
            tempArr.push(element);
          }
        });
      } else if (this.typeActive == 3) {
        this.recordList.forEach(function (element) {
          if (element.asset_type == "3" || element.asset_type == "4") {
            tempArr.push(element);
          }
        });
      } else if (this.typeActive == 4) {
        this.recordList.forEach(function (element) {
          if (element.asset_type == "5" || element.asset_type == "6") {
            tempArr.push(element);
          }
        });
      }

      return tempArr;
    }
  }),
  methods: {
    routeSplicing: _routeSplicing.default,
    timestampToDate: _formatDate.timestampToDate,
    timestampToDay: _formatDate.timestampToDay,
    timestamp: _formatDate.timestamp,
    translateTitle: _i18n.translateTitle,
    onClickAll: function onClickAll() {
      this.sellNumber = this.apiAssetsInfo;
    },
    onCancelClick: function onCancelClick() {
      this.takeOutDialogVisible = false;
      this.sellNumber = "";
    },
    onHolderDialogClose: function onHolderDialogClose() {
      this.detailDialogVisible = false;
      this.typeActive = 1;
    },
    onProductInfoChange: function onProductInfoChange(productInfo) {
      this.productInfo = productInfo;
    },
    onDialogClose: function onDialogClose() {
      this.financialDialogVisible = false;
    },
    onConfirm: function onConfirm() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.getProductInfo();

              case 2:
                _this2.confirmDialogVisible = true;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onConfirmCancel: function onConfirmCancel() {
      this.confirmDialogVisible = false;
    },
    onConfirmOK: function onConfirmOK() {
      this.confirmDialogVisible = false;
      this.financialDialogVisible = false;
      (0, _message.showMessage)({
        message: this.translateTitle("\u5B58\u5165\u6210\u529F"),
        type: "success"
      });
      this.holdDetail(this.rowData); // this.successDialogVisible = true;
    },
    onTakeOut: function onTakeOut(row) {
      var _this3 = this;

      this.productId = row.product_id;
      this.takeOutDialogLoading = true;
      this.rowData = row;
      this.apiAssetsInfo = row.amount;

      if (row.product_type == 3) {
        this.takeOutDialogTitle = this.translateTitle("\u91CF\u5316\u7406\u8D22\u53D6\u51FA");
      } else if (row.product_type == 2) {
        this.takeOutDialogTitle = this.translateTitle("\u6D3B\u671F\u5B58\u6B3E\u53D6\u51FA");
      } else if (row.product_type == 1) {
        this.takeOutDialogTitle = this.translateTitle("\u5B9A\u671F\u5B58\u6B3E\u53D6\u51FA");
      } else if (row.product_type == 4) {
        this.takeOutDialogTitle = this.translateTitle("\u91CF\u5316\u53D6\u51FA");
      }

      var params = {
        ufp_id: row.ufp_id
      };
      (0, _finance.apiGetPositionInfo)(params).then(function (res) {
        if (res.status == 200) {
          _this3.holderPositionInfo = res.data;
          _this3.takeOutDialogVisible = true;
        }
      });
      this.getProductInfo();
      setTimeout(function () {
        _this3.takeOutDialogLoading = false;
      }, 500);
    },
    onOK: function onOK() {
      var _this4 = this;

      if (this.sellNumber == "") {
        (0, _message.showMessage)({
          message: this.translateTitle("请输入取出金额"),
          type: "error"
        });
        return;
      }

      if (Number(this.sellNumber) > Number(this.apiAssetsInfo)) {
        (0, _message.showMessage)({
          message: this.translateTitle("取出数量不能超过总持仓"),
          type: "warning"
        });
        return;
      }

      this.btnLoading = true;
      var params = {
        ufp_id: this.rowData.ufp_id,
        num: this.sellNumber
      };
      (0, _finance.apiSellFinances)(params).then(function (res) {
        if (res.status == 200) {
          _this4.sellNumber = "";
          (0, _message.showMessage)({
            message: _this4.translateTitle("\u53D6\u51FA\u6210\u529F"),
            type: "success"
          }); // setTimeout(async () => {

          _this4.getAssetsList();

          _this4.holdDetail(_this4.rowData);

          _this4.getAllItemData(); // }, 100);


          _this4.takeOutDialogVisible = false;
        }

        _this4.btnLoading = false;
      });
    },
    onAreaChange: function onAreaChange(item) {
      this.currIndex = item.value;
    },
    onPositionChange: function onPositionChange(item) {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.currIndexPosition = item.value;

                if (!(item.value == 2)) {
                  _context4.next = 6;
                  break;
                }

                _this5.historytableLoading = true;
                _context4.next = 5;
                return _this5.getHistoryPositionList();

              case 5:
                _this5.getAllHistoryPositionItemData();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getAssetsData: function getAssetsData() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _yield$getAssetsList, status, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return (0, _index2.getAssetsList)();

              case 2:
                _yield$getAssetsList = _context5.sent;
                status = _yield$getAssetsList.status;
                data = _yield$getAssetsList.data;

                if (status == 200) {
                  _this6.assetsList = data;
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    rechargeClick: function rechargeClick(row) {
      if (row.in_status === 0) {
        var coinName = row.item_name.toUpperCase();
        (0, _message.showMessage)({
          message: coinName + this.translateTitle("\u6682\u4E0D\u652F\u6301\u5145\u5E01")
        });
      } else {
        // sessionStorage.setItem("currentCoin", JSON.stringify(row));
        localStorage.setItem("currentCoin", JSON.stringify(row));
        this.$router.push({
          path: this.routeSplicing(this.language, "ucenter/assets/recharge/" + row.item_name.toLowerCase())
        });
      }
    },
    onGoOnBuy: function onGoOnBuy(row) {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (row) {
                  _this7.productId = row.product_id;
                } else {
                  _this7.productId = _this7.rowData.product_id;
                }

                _context6.next = 3;
                return _this7.getProductInfo();

              case 3:
                if (row.product_type == 3) {
                  _this7.confirmDialogTitle = _this7.translateTitle("\u91CF\u5316\u7406\u8D22");
                } else if (row.product_type == 2) {
                  _this7.confirmDialogTitle = _this7.translateTitle("\u6D3B\u671F\u5B58\u6B3E");
                } else if (row.product_type == 1) {
                  _this7.confirmDialogTitle = _this7.translateTitle("\u5B9A\u671F\u5B58\u6B3E");
                } else if (row.product_type == 4) {
                  if (_stationSetting.VUE_APP_ID == "AwyOTFRlsfQ5mRkqwCNaEd5T" || _stationSetting.VUE_APP_ID == "DwyOTFRlsfQ5mRkqwCNaEd5T" || _stationSetting.VUE_APP_ID == "J8tstegyx2UjYzJ6J1vNuD3w") {
                    _this7.confirmDialogTitle = _this7.translateTitle("\u6C47\u4FE1\u6C60");
                  } else {
                    _this7.confirmDialogTitle = "Launchpad";
                  }
                }

                _this7.confirmDialogVisible = true;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    // 产品详情弹窗
    productInfoClick: function productInfoClick(row) {
      this.productId = row.product_id;
      this.financialDialogVisible = true;
    },
    // 持有详情
    holdDetail: function holdDetail(row) {
      var _this8 = this;

      this.rowData = row;
      this.detailLoading = true;
      var params = {
        ufp_id: row.ufp_id
      };
      (0, _finance.apiGetPositionInfo)(params).then(function (res) {
        if (res.status == 200) {
          _this8.productInfo = res.data;

          if (res.data.turnover.length > 0) {
            var tempArr = res.data.turnover;
            tempArr.forEach(function (ele) {
              for (var key in _this8.coinInfoMap) {
                if (ele.item_id == key) {
                  ele.item_name = _this8.coinInfoMap[key].item_name.toUpperCase();
                  ele.item_url = _this8.coinInfoMap[key].itemDetail.coin_url;
                }
              }
            });
            _this8.recordList = tempArr;
          }

          var now_time = (new Date().getTime() / 1000).toFixed();
          _this8.productInfo.now_time = now_time;

          if (_this8.productInfo.product_type == 1) {
            _this8.rate1 = (now_time - _this8.productInfo.period_start_time) / (_this8.productInfo.period_stop_time - _this8.productInfo.period_start_time);
            _this8.rate1 = _this8.rate1 > 1 ? 1 : _this8.rate1;
            _this8.rate2 = (now_time - _this8.productInfo.start_time) / (_this8.productInfo.stop_time - _this8.productInfo.start_time);
            _this8.rate2 = _this8.rate2 > 1 ? 1 : _this8.rate2;
          } else if (_this8.productInfo.product_type == 3) {
            _this8.rate1 = (now_time - _this8.productInfo.create_time) / (_this8.productInfo.start_time - _this8.productInfo.create_time);
            _this8.rate1 = _this8.rate1 > 1 ? 1 : _this8.rate1;
            _this8.rate2 = (now_time - _this8.productInfo.start_time) / (_this8.productInfo.stop_time - _this8.productInfo.start_time);
            _this8.rate2 = _this8.rate2 > 1 ? 1 : _this8.rate2;
          } else if (_this8.productInfo.product_type == 4) {
            _this8.rate1 = (now_time - _this8.productInfo.create_time) / (_this8.productInfo.start_time - _this8.productInfo.create_time);
            _this8.rate1 = _this8.rate1 > 1 ? 1 : _this8.rate1;
            _this8.rate2 = (now_time - _this8.productInfo.period_start_time) / (_this8.productInfo.end_time - _this8.productInfo.period_start_time);
            _this8.rate2 = _this8.rate2 > 1 ? 1 : _this8.rate2;
          } // 1为未开始，2为计息中，3为已完成,4为收益已发放


          if (_this8.productInfo.status == 1) {
            _this8.stepActive = 1;
          } else if (_this8.productInfo.status == 2) {
            _this8.stepActive = 2;
          } else if (_this8.productInfo.status >= 3) {
            _this8.stepActive = 3;
          }

          for (var key in _this8.coinInfoMap) {
            if (key == _this8.productInfo.ico_real_amount_item_id) {
              _this8.productInfo.real_item_name = _this8.coinInfoMap[key].item_name.toUpperCase();
            }

            if (key == _this8.productInfo.item_id) {
              _this8.productInfo.item_name = _this8.coinInfoMap[key].item_name.toUpperCase();
            }

            if (_this8.productInfo.pre_earnings_item_id == key) {
              _this8.productInfo.pre_earnings_item_name = _this8.coinInfoMap[key].item_name.toUpperCase();
              _this8.productInfo.pre_earnings_item_url = _this8.coinInfoMap[key].itemDetail.coin_url;
            }
          }
        }

        _this8.detailLoading = false;
      });
      this.detailDialogVisible = true;
    },
    getProductInfo: function getProductInfo() {
      var _this9 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var params, _yield$apiGetFinances, status, data, tempObj;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                params = {
                  product_id: _this9.productId
                };
                _this9.confirmDialogLoading = true;
                _context7.next = 4;
                return (0, _finance.apiGetFinancesProductInfo)(params);

              case 4:
                _yield$apiGetFinances = _context7.sent;
                status = _yield$apiGetFinances.status;
                data = _yield$apiGetFinances.data;

                if (status == 200) {
                  tempObj = data.productInfo;
                  tempObj.annual_rate = tempObj.annual_rate * 100;
                  _this9.apiProductInfo = tempObj;
                }

                _this9.confirmDialogLoading = false;

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    getAllItemDataOnce: function getAllItemDataOnce() {
      this.tableLoading = true;
      this.getAllItemData();
    },
    getAllItemData: function getAllItemData() {
      var _this10 = this;

      var tempAssets = [];
      tempAssets = this.assetsList.list;
      tempAssets.forEach(function (ele) {
        for (var key in _this10.symbolList) {
          if (ele.item_id == key) {
            ele.item_name = _this10.symbolList[key].item_name.toUpperCase();
          }

          if (ele.ico_base_item_id == key) {
            ele.to_item_name = _this10.symbolList[key].item_name.toUpperCase();
          }
        }

        var now_time = (new Date().getTime() / 1000).toFixed();
        ele.now_time = now_time;
        ele.remain_time = ele.start_time * 1000 - now_time;
      });
      this.pageInfo.pageTotal = tempAssets.length;
      this.pageInfo.pageCount = Math.ceil(this.pageInfo.pageTotal / this.pageInfo.pageSize);
      this.dataList = tempAssets.slice((this.pageInfo.pageCurrent - 1) * this.pageInfo.pageSize, this.pageInfo.pageCurrent * this.pageInfo.pageSize);
      this.tableLoading = false;
    },
    //理财产品历史持仓数据处理
    getAllHistoryPositionItemData: function getAllHistoryPositionItemData() {
      var _this11 = this;

      var tempHistoryPositionList = [];
      tempHistoryPositionList = this.historyPositionList;
      tempHistoryPositionList.forEach(function (ele) {
        for (var key in _this11.symbolList) {
          if (ele.item_id == key) {
            ele.item_name = _this11.symbolList[key].item_name.toUpperCase();
          }
        }
      });
      this.historyPositionPageInfo.pageTotal = tempHistoryPositionList.length;
      this.historyPositionPageInfo.pageCount = Math.ceil(this.historyPositionPageInfo.pageTotal / this.historyPositionPageInfo.pageSize);
      this.historyPositionDataList = tempHistoryPositionList.slice((this.historyPositionPageInfo.pageCurrent - 1) * this.historyPositionPageInfo.pageSize, this.historyPositionPageInfo.pageCurrent * this.historyPositionPageInfo.pageSize);
      this.historytableLoading = false;
    },
    // 获取资产列表
    getAssetsList: function getAssetsList() {
      var _this12 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                params = {
                  type: "finance"
                };
                _context8.next = 3;
                return (0, _index.apiGetAssets)(params);

              case 3:
                _yield$apiGetAssets = _context8.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status === 200) {
                  _this12.assetsList = data.finance;
                  _this12.last_profit = data.finance.last_profit;
                  _this12.total_profit = data.finance.total_profit;
                  _this12.u_valuation = data.finance.u_valuation;
                  _this12.pre_earnings_amount = data.finance.pre_earnings_amount;
                  _this12.all_last_valuation = data.finance.all_last_valuation;
                  _this12.all_total_valuation = data.finance.all_total_valuation;
                  _this12.all_pre_earnings_valuation = data.finance.all_pre_earnings_valuation;
                  _this12.assetsShowCurrency = data.finance.all_u_valuation;
                }

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 获取理财产品历史持仓列表
    getHistoryPositionList: function getHistoryPositionList() {
      var _this13 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _yield$apiGetHistoryP, status, data;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return (0, _finance.apiGetHistoryPositionList)();

              case 2:
                _yield$apiGetHistoryP = _context9.sent;
                status = _yield$apiGetHistoryP.status;
                data = _yield$apiGetHistoryP.data;

                if (status === 200) {
                  _this13.historyPositionList = data.list;
                }

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    getStaticTableInfo: function getStaticTableInfo(sv_id) {
      var _this14 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(sv_id);

              case 2:
                _yield$apiGetStaticTa = _context10.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this14.symbolList = JSON.parse(JSON.stringify(data));
                  _this14.coinInfoMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    sortObj: function sortObj(obj) {
      if (obj[10007]) {
        obj[10007].order_by = -1;
      }

      var keys = Object.keys(obj).sort(function (a, b) {
        return obj[a].order_by - obj[b].order_by;
      });
      var newObj = [];

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        newObj.push(obj[key]);
      }

      return newObj;
    },
    onTypeChange: function onTypeChange(val) {
      this.typeActive = val;
    },
    onPageChange: function onPageChange() {
      this.getAllItemData();
    },
    onHistoryPositionPageChange: function onHistoryPositionPageChange() {
      this.getAllHistoryPositionItemData();
    }
  }
};
exports.default = _default;